// Enum representing the type of uploaded file.
export enum FileUploadType {
  TlsRootCertificate = 0,
  TerminalSetupFile = 1,
  Firmware = 2,
}
